import * as Sentry from '@sentry/react';
import PropTypes from 'prop-types';
import React from 'react';

export default class ErrorBoundary extends React.Component {
  static getDerivedStateFromError(error: any) {
    return { hasError: true, error };
  }

  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  };

  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // TODO - Capture error by Exception monitor
    console.log({ error, errorInfo });

    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo);
      Sentry.captureException(error);
    });

    if (process.env.NODE_ENV !== 'development') {
      this.handleError();
    }
  }

  /**
   * Redirected to the home page after got unhandled errors
   */
  handleError = () => {
    if (window.location.pathname !== '/') {
      window.history.pushState(null, '', '?site_error=true');
    }
  };

  render() {
    const { children } = this.props as any;
    const { hasError } = this.state as any;

    // Render Error page in case of default page crash
    if (hasError && window.location.pathname === '/') {
      return <div>Error</div>;
    }

    return children;
  }
}
